import { ASSETS_API_HOST } from 'appConstants';
import axios from 'axios';
import qs from 'qs';

const httpCopyFromGlobalToTemplateAssets = (id, imageName, type) => {
  return axios.get(`/api/v2/assets/template/${id}/${imageName}`, {
    params: { type },
  });
};

const httpGetGlobalAssets = (params) => {
  return axios.get('/api/v2/assets/user', {
    params,
    paramsSerializer: (queryParams) =>
      qs.stringify(queryParams, { arrayFormat: 'repeat', skipNulls: true }),
  });
};

const httpGetGlobalAsset = (savedName, params) => {
  return axios.get(`/api/v2/assets/user/${savedName}`, { params });
};

const httpGetAssets = (id, type) => {
  return axios.get(`/api/v2/assets/template/${id}`, { params: { type } });
};

const httpUploadAssets = (payload) => {
  return axios.post('/api/v2/assets', payload);
};

const httpDeleteGlobalAsset = (assetName, type) => {
  return axios.delete(`/api/v2/assets/${assetName}`, { params: { type } });
};

const httpUpdateGlobalAsset = (assetName, type, payload) => {
  return axios.put(`/api/v2/assets/${assetName}`, payload, {
    params: { type },
  });
};

const httpDeleteAsset = (id, payload, type) => {
  return axios.delete(`/api/v2/assets/template/${id}`, {
    data: payload,
    params: { type },
  });
};

const httpUnsplash = (url) => {
  const payload = { method: 'GET', url };

  return axios.post('/unsplash', payload, { baseURL: ASSETS_API_HOST });
};

const httpAiImages = (payload) => {
  return axios.post('/api/v2/ai/image', payload);
};

const httpSearchIcons = (url) => {
  const payload = { method: 'GET', url };

  return axios.post('/icons', payload, { baseURL: ASSETS_API_HOST });
};

const httpGetFolders = (type) => {
  return axios.get('/api/v2/assets/folders', { params: { type } });
};

const httpCreateFolder = (payload) => {
  return axios.post('/api/v2/assets/folders', payload);
};

export {
  httpCopyFromGlobalToTemplateAssets,
  httpGetGlobalAssets,
  httpGetGlobalAsset,
  httpGetAssets,
  httpUploadAssets,
  httpDeleteGlobalAsset,
  httpDeleteAsset,
  httpUnsplash,
  httpAiImages,
  httpSearchIcons,
  httpGetFolders,
  httpCreateFolder,
  httpUpdateGlobalAsset,
};
